var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "el-empty",
        {
          attrs: {
            image: _vm.img,
            "image-size": 223,
            description: "您的服务已到期，请联系管理员",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#909399",
                "margin-bottom": "20px",
              },
            },
            [_vm._v("客服电话：029-85799709")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.renewal },
            },
            [_vm._v("立即续费")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }